import { render, staticRenderFns } from "./AssigmentDetail.vue?vue&type=template&id=3495fb2f&scoped=true"
import script from "./AssigmentDetail.vue?vue&type=script&lang=js"
export * from "./AssigmentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3495fb2f",
  null
  
)

export default component.exports